/**
 * Geocode an address using the free Nominatim (OpenStreetMap) API.
 * Returns { latitude, longitude } or null if not found.
 */
export async function geocodeAddress(
  address?: string,
  city?: string,
  postal?: string
): Promise<{ latitude: number; longitude: number } | null> {
  const parts = [address, postal, city].filter(Boolean).join(", ");
  if (!parts.trim()) return null;

  try {
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(parts)}&format=json&limit=1`;
    const res = await fetch(url, {
      headers: { "Accept-Language": "fr", "User-Agent": "HexaflowApp/1.0" },
    });
    const data = await res.json();
    if (!data || data.length === 0) return null;
    return {
      latitude: parseFloat(data[0].lat),
      longitude: parseFloat(data[0].lon),
    };
  } catch {
    return null;
  }
}
